import { USE_CASE_ERROR_CODE, UseCaseDomainErrors, UseCaseError } from '@carlito/ddd';

export function extractApiErrorCodes(e: unknown) {
  if (e instanceof UseCaseDomainErrors) {
    return e.domainErrors.map((e) => e.errorCode);
  }
  if (e instanceof UseCaseError) {
    return [e.errorCode];
  }

  if (e instanceof Error) {
    return [USE_CASE_ERROR_CODE.UNEXPECTED_ERROR];
  }

  if (typeof e === 'string') {
    return [e];
  }

  return null;
}
